export default __webpack_public_path__ + "static/media/featRaceBgMb.bc4df50b.png";